import React from "react";
import { Navigate } from "react-router-dom";

export const withAuth = (Component) => {
  const accessToken = localStorage.getItem("accessToken");

  return class extends React.Component {
    render() {
      if (accessToken === null) {
        return <Navigate to="/login" />;
      }

      return <Component {...this.props} />;
    }
  };
};
